export default __webpack_public_path__ + "static/media/avatar_2@2x.95178f92.png";